import {DialogContent, Switch} from '@mui/material'
import Dialog from 'components/Display/Dialog/Dialog'
import {styled} from 'common'
import {useState} from 'react'
import {useI18n} from 'store/Store'
import Link from '@mui/material/Link'
import {useSavePlannerCrmMutation} from 'store/slices/api/crmsApi'

const CrmsItem = ({crm}) => {
    const {i18n} = useI18n()
    const [showTerms, setShowTerms] = useState(false)
    const [doSavePlannerCrm] = useSavePlannerCrmMutation()

    return (
        <>
            <Container>
                <Switch
                    onChange={(e, checked) => {
                        if (checked) {
                            setShowTerms(true)
                        } else {
                            doSavePlannerCrm({
                                crmKey: crm.crmKey,
                                isActive: false,
                            })
                        }
                    }}
                    checked={crm.plannerCrmIsActive}
                />
                {crm.crm}
            </Container>
            <Dialog
                fullWidth
                maxWidth="lg"
                title={i18n.t('settings.crmsList.termsApproval')}
                open={showTerms}
                handleClose={() => setShowTerms(false)}
                handleSave={() =>
                    doSavePlannerCrm({
                        crmKey: crm.crmKey,
                        isActive: true,
                    })
                }
                onCancel={() => setShowTerms(false)}
                saveButtonText={i18n.t('form.confirm')}
                isValid={true}>
                <DialogContent>
                    <Link
                        href={`https://www.familybiz.co.il/legal/${crm.crm}/terms`}>
                        {i18n.t('settings.crmsList.termsLink')}
                    </Link>
                </DialogContent>
            </Dialog>
        </>
    )
}
export default CrmsItem

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 60px;
`
